import React from "react";
import { connect } from 'react-redux';
import moment from "moment";
import ReactDatetime from "react-datetime";
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Table, Modal, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Alert } from "reactstrap";
import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
import api from "./../../Api.js";
import ModalImportHolidays from "./modal/ModalImportHolidays.jsx";

class CronogramaFeriados extends React.Component {

    constructor(props){

        super(props);

        this.state = {

            holidays: [],
            loadHolidays: false,

            openModal: false,
            openModalImport: false,
            edit: undefined,
            dialog: { description: "", startDate: "", endDate: "" },
            erro: ""

        };

        this.getHolidays = this.getHolidays.bind(this);
        this.saveHoliday = this.saveHoliday.bind(this);
        this.deleteHoliday = this.deleteHoliday.bind(this);

        window.cronogramaferiados = this;

    }

    componentDidMount(){

        this.getHolidays();

    }

    //Verifica se o usuário pode gerenciar feriados (a validação final é do backend)
    canManage(){

        if(this.props.permission.indexOf(15) !== -1){ return true; }
        if(parseInt(this.props.user.accessLevel) === 5){ return true; }
        return false;

    }

    //Para listar os feriados e recessos
    async getHolidays(){

        await api.getHolidays().then((res) => {

            this.setState({ holidays: res.data, loadHolidays: true });

        }).catch(error => { console.log(error); this.setState({ loadHolidays: true }); });

    }

    //Para cadastrar ou atualizar um feriado
    async saveHoliday(event){

        event.preventDefault();

        var data = { description: this.state.dialog.description, startDate: this.state.dialog.startDate };
        data.endDate = (this.state.dialog.endDate !== "") ? this.state.dialog.endDate : null;

        var request;

        if(this.state.edit === undefined){ request = api.postHoliday(data); }else{ request = api.putHoliday(this.state.edit, data); }

        await request.then((res) => {

            this.setState({ openModal: false, erro: "" });
            this.getHolidays();
            window.swal.fire(this.props.translate['sucesso'] || 'Sucesso!', res.data.msg, 'success');

        }).catch(error => {

            console.log(error);
            if(error.response !== undefined && error.response.data !== undefined){ this.setState({ erro: error.response.data.msg }); }

        });

    }

    //Para remover um feriado
    async deleteHoliday(holiday){

        var result = await window.swal.fire({
            title: this.props.translate['remover_feriado'] || 'Remover feriado?',
            text: holiday.description,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: this.props.translate['remover'] || 'Remover',
            cancelButtonText: this.props.translate['cancelar'] || 'Cancelar'
        });

        if(!result.isConfirmed){ return false; }

        await api.deleteHoliday(holiday.id).then((res) => {

            this.getHolidays();

        }).catch(error => {

            console.log(error);
            if(error.response !== undefined && error.response.data !== undefined){ window.swal.fire('Ops!', error.response.data.msg, 'error'); }

        });

    }

    render(){

        const translate = this.props.translate;
        const canManage = this.canManage();

        const handleChange = name => event => {
            var dialog = this.state.dialog;
            dialog[name] = event.target.value;
            this.setState({ dialog: dialog });
        }

        const handleDate = name => value => {
            var dialog = this.state.dialog;
            try { dialog[name] = value.format('YYYY-MM-DD'); } catch (error) { dialog[name] = ""; }
            this.setState({ dialog: dialog });
        }

        return(<React.Fragment>

            <SimpleHeader name={translate['feriados_e_recessos'] || "Feriados e recessos"} way={[{ name: translate['cronograma'] || "Cronograma", url: "/cronograma" }, { name: translate['feriados_e_recessos'] || "Feriados e recessos", url: "/cronograma/feriados" }]} buttons={<React.Fragment></React.Fragment>} />

            <Container className="mt--6" fluid>

                <Card>

                    <CardHeader className="border-0">
                        <Row className="align-items-center">
                            <Col xs="6"><h3 className="mb-0">{translate['feriados_e_recessos'] || "Feriados e recessos"}</h3></Col>
                            <Col xs="6" className="text-right">
                                {canManage &&
                                    <Button color="secondary" onClick={() => this.setState({ openModalImport: true })}>
                                        <i className="fas fa-file-import mr-2" />{translate['importar'] || "Importar"}
                                    </Button>
                                }
                                {canManage &&
                                    <Button color="primary" onClick={() => this.setState({ openModal: true, edit: undefined, erro: "", dialog: { description: "", startDate: "", endDate: "" } })}>
                                        <i className="fas fa-plus mr-2" />{translate['novo_feriado'] || "Novo feriado/recesso"}
                                    </Button>
                                }
                            </Col>
                        </Row>
                        <p className="text-muted mb-0 mt-2"><small>{translate['feriados_ajuda'] || "As aulas geradas no cronograma pulam automaticamente essas datas. Para períodos (Carnaval, recesso de julho, fim de ano), preencha início e fim."}</small></p>
                    </CardHeader>

                    <CardBody>

                        {(!this.state.loadHolidays) && <center><ClipLoader color="#adb5bd" size={30} /></center>}

                        {(this.state.loadHolidays && this.state.holidays.length === 0) &&
                            <Alert color="secondary">{translate['nenhum_feriado'] || "Nenhum feriado ou recesso cadastrado."}</Alert>
                        }

                        {(this.state.loadHolidays && this.state.holidays.length > 0) &&
                            <Table className="align-items-center table-flush" responsive hover>
                                <thead className="thead-light">
                                    <tr>
                                        <th>{translate['descricao'] || "Descrição"}</th>
                                        <th>{translate['inicio'] || "Início"}</th>
                                        <th>{translate['fim'] || "Fim"}</th>
                                        {canManage && <th className="text-right">{translate['acoes'] || "Ações"}</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.holidays.map((holiday, index) => (
                                        <tr key={index}>
                                            <td>{holiday.description}</td>
                                            <td>{moment(holiday.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</td>
                                            <td>{(holiday.endDate !== null) ? moment(holiday.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : '—'}</td>
                                            {canManage &&
                                                <td className="text-right">
                                                    <Button size="sm" color="secondary" title={translate['editar'] || "Editar"} onClick={() => this.setState({ openModal: true, edit: holiday.id, erro: "", dialog: { description: holiday.description, startDate: holiday.startDate, endDate: (holiday.endDate !== null) ? holiday.endDate : "" } })}>
                                                        <i className="fas fa-edit" />
                                                    </Button>
                                                    <Button size="sm" color="danger" title={translate['remover'] || "Remover"} onClick={() => this.deleteHoliday(holiday)}>
                                                        <i className="fas fa-trash" />
                                                    </Button>
                                                </td>
                                            }
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        }

                    </CardBody>

                </Card>

            </Container>

            {/* ------------------------- MODAL FERIADO ------------------------- */}
            <Modal className="modal-dialog-centered" isOpen={this.state.openModal} toggle={() => this.setState({ openModal: false })}>
                <div className="modal-header">
                    <h5 className="modal-title">{(this.state.edit === undefined) ? (translate['novo_feriado'] || "Novo feriado/recesso") : (translate['editar_feriado'] || "Editar feriado/recesso")}</h5>
                    <button aria-label="Close" className="close" type="button" onClick={() => this.setState({ openModal: false })}><span aria-hidden={true}>×</span></button>
                </div>
                <div className="modal-body">
                    {(this.state.erro) && <Alert color="danger"><strong>{translate['ops'] || "Ops"}!</strong> {this.state.erro}</Alert>}
                    <Form role="form" onSubmit={(event) => this.saveHoliday(event)}>
                        <h5>{translate['descricao'] || "Descrição"}:</h5>
                        <FormGroup>
                            <Input type="text" value={this.state.dialog.description} onChange={handleChange('description')} placeholder="Carnaval, Recesso de julho..." required />
                        </FormGroup>
                        <Row>
                            <Col md="6">
                                <h5>{translate['inicio'] || "Início"}:</h5>
                                <FormGroup>
                                    <InputGroup className="input-group-merge input-group-alternative">
                                        <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon>
                                        <ReactDatetime autoComplete="off" locale="pt-br" dateFormat="DD/MM/YYYY" timeFormat={false}
                                            value={this.state.dialog.startDate !== "" ? moment(this.state.dialog.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""}
                                            onChange={handleDate('startDate')} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <h5>{translate['fim_opcional'] || "Fim (opcional)"}:</h5>
                                <FormGroup>
                                    <InputGroup className="input-group-merge input-group-alternative">
                                        <InputGroupAddon addonType="prepend"><InputGroupText><i className="ni ni-calendar-grid-58" /></InputGroupText></InputGroupAddon>
                                        <ReactDatetime autoComplete="off" locale="pt-br" dateFormat="DD/MM/YYYY" timeFormat={false}
                                            value={this.state.dialog.endDate !== "" ? moment(this.state.dialog.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ""}
                                            inputProps={{ placeholder: translate['so_um_dia'] || "Só um dia" }}
                                            onChange={handleDate('endDate')} />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button color="default" type="button" onClick={() => this.setState({ openModal: false })}>{translate['cancelar'] || "Cancelar"}</Button>
                            <Button color="primary" type="submit">{translate['salvar'] || "Salvar"}</Button>
                        </div>
                    </Form>
                </div>
            </Modal>

            <ModalImportHolidays
                isOpen={this.state.openModalImport}
                close={() => this.setState({ openModalImport: false })}
                successImport={(resultado) => { this.setState({ holidays: resultado.holidays }); }}
            />

        </React.Fragment>)

    }

}

export default connect(state => ({

    languages: state.language,
    translate: state.translate,
    accesslevel: state.accesslevel,
    permission: state.permission,
    user: state.user,

}))(CronogramaFeriados);
